

<template>
  <b-row v-if="esAlergio">
    <b-col>
      <b-card
        
        no-body
        :class="{ 'open': visibleBody }"
      >

        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA ALERGIOLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding:1.5rem">
            <!-- <PreguntasAlergolo/> -->


            <div>
              <b-row class="my-1 d-flex align-items-center">

                <label 
                  for="" 
                  style="font-size: small;" 
                  class="col-3"
                >
                  Posibles causantes
                </label>            

                <v-select
                  class="col-9"
                  placeholder="Seleccione una o mas opciones"
                  :options="causasAlergiaOpts"
                  :reduce="option => option"
                  label="text"
                  :multiple="true"
                  taggable
                  @input="newArray => preguntas.causantes = onAddNewOpt(newArray)"
                />

              </b-row>

              <b-row class="my-1 d-flex align-items-center">

                <label 
                  for="" 
                  style="font-size: small;" 
                  class="mb-1 col-3"
                >
                  Sintomas
                </label>            

                <v-select
                  class="col-9"
                  placeholder="Seleccione una o mas opciones"
                  :options="sintomasOpts"
                  :reduce="option => option"
                  label="text"
                  :multiple="true"
                  taggable
                  @input="newArray => preguntas.sintomas = onAddNewOpt(newArray)"
                />

              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <label class="col-3">Comienzo</label>

                <b-form-input 
                  class="col-2 ml-1"
                  type="number"
                  min="0"
                  max="99"
                  v-model="preguntas.comienzoNumero"
                />

                <v-select
                  class="col-4"
                  placeholder="Desde cuando"
                  :options="tipoTiempoOpts"
                  :reduce="option => option"
                  label="text"
                  v-model="preguntas.comienzoTipo"
                />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">

                <label 
                  for="" 
                  style="font-size: small;" 
                  class="mb-1 col-3"
                >
                  Exposicion
                </label>            

                <v-select
                  class="col-9"
                  placeholder="Seleccione una o mas opciones"
                  :options="exposicionOpts"
                  :reduce="option => option"
                  label="text"
                  :multiple="true"
                  taggable
                  @input="newArray => preguntas.exposicion = onAddNewOpt(newArray)"
                />

              </b-row>

              <div class="my-2">
                <b-form-checkbox
                  v-model="preguntas.observaciones.active"
                >
                  <label for="">Observaciones Adicionales:</label>
                </b-form-checkbox>

                <b-form-textarea
                  v-if="preguntas.observaciones.active"
                  v-model="preguntas.observaciones.text"
                />
              </div>
            </div>


          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';
import { mapState } from 'vuex';


export default {

  name: "SemiologiaAlergiologica",

  components: {
    vSelect
  },
  
  data() {
    return {
      visibleBody:true,

      preguntas:{
        causantes:[],
        sintomas:[],
        comienzoNumero: null,
        comienzoTipo: null,
        exposicion:[],

        observaciones: {
          active: false,
          text: null
        }
      },

      causasAlergiaOpts: [
        { value: 'penicilina',        text: 'Penicilina' },
        { value: 'sulfonamidas',      text: 'Sulfonamidas' },
        { value: 'antiinflamatorios', text: 'Antiinflamatorios no esteroides (AINEs)' },
        { value: 'anticonvulsivos',   text: 'Anticonvulsivos' },

        { value: 'leche',    text: 'Leche' },
        { value: 'huevos',   text: 'Huevos' },
        { value: 'nueces',   text: 'Nueces, almendras, etc.' },
        { value: 'pescado',  text: 'Pescado' },
        { value: 'mariscos', text: 'Mariscos' },
        { value: 'soya',     text: 'Soya' },
      ],

      sintomasOpts:[
        { value: 'estornudos',      text: 'Estornudos' },
        { value: 'congestion',      text: 'Congestión nasal' },
        { value: 'picazonBoca',     text: 'Picazón en la boca o garganta' },
        { value: 'urticaria',       text: 'Urticaria (ronchas)' },
        { value: 'respirar',        text: 'Dificultad para respirar' },
        { value: 'dolorAbdominal',  text: 'Dolor abdominal' },
        { value: 'nauseas',         text: 'Náuseas o vómitos' },
        { value: 'diarrea',         text: 'Diarrea' },
        { value: 'hinchazonLabios', text: 'Hinchazon de labios, lengua o garganta' },
        { value: 'anafilaxia',      text: 'Anafilaxia (reaccion alrégica grave)' }
      ],

      tipoTiempoOpts:[
        { value: 'dias',    text: 'Dias' },
        { value: 'semanas', text: 'Semanas' },
        { value: 'meses',   text: 'Meses' },
        { value: 'anios',   text: 'Años' },
      ],

      exposicionOpts:[
        { value: 'humo_de_tabaco',         text: 'Humo de tabaco' },
        { value: 'productos_de_limpieza',  text: 'Productos de limpieza' },
        { value: 'perfumes',               text: 'Perfumes o aerosoles' },
        { value: 'animales_domesticos',    text: 'Animales domesticos' },
        { value: 'humedad',                text: 'Ambientes humedos o mohosos' },
        { value: 'ninguno',                text: 'Ninguno' },
      ],
      
    };
  },
  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },
  },

  watch:{
    preguntas: {
      deep: true,
      handler(newValue){
        this.$store.commit("setAlergologicaPreguntas", newValue);
      }
    },

    stSemAlergologica: {
      deep: true,
      handler(newValue) {
        const semiologia = { tipo:'alergologica', data:newValue }
        this.$store.commit("setSemiologia", semiologia );
      }
    },
  },

  computed: {
    ...mapState({
      stSemAlergologica: state => state.atencionCita.semiologias?.semAlergologica,
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esAlergio(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000586';
    },
  },
  
};
</script>